import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { 
    Dialog,
    DialogTitle,
    Divider,
    DialogContent,
    Typography,
    DialogActions,
    TextField,
    Stack

 } from '@mui/material';

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import SaveIcon from '@mui/icons-material/Save';

import { 
    selectIsSuccess,
    selectMessage,
    fetchInsertOrUpdateSemanaAlmuerzo 
} from '../../../../redux/Cafeteria/CafeteriaSlice';

export const AddOrUpdateModal = ({open = {data: {}, enable: true}, setOpen}) => {

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-SELECTOR
    const success = useSelector(selectIsSuccess);
    const message = useSelector(selectMessage);

    // * VALIDACIONES DEL HOOK-FORM.
    const formSchema = Yup.object().shape({
        semana: Yup.object().shape({
          id: Yup.number(),
          fechaInicio: Yup.date()
            .required("El campo es requerido"),
          fechaTermino: Yup.date()
            .required("El campo es requerido.")
            .when("fechaInicio", (fechaInicio, schema) => 
              fechaInicio 
                ? schema.min(fechaInicio, "La fecha de término debe ser igual o mayor a la fecha de inicio.") 
                : schema
            ),
          estatus: Yup.boolean()
            .required("El campo es requerido."),
        }),
    });

    // ? HOOK-FORM
    const { 
        control, 
        register,
        watch,
        reset,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm({
            mode: "onTouched",
            resolver: yupResolver(formSchema),
            defaultValues: {
                semana: {
                    id: 0,
                    fechaInicio: new Date(),
                    fechaTermino: new Date(),
                    estatus: true
                }
            }
        });

    // ? HOOK-EFFECT PARA CERRAR LIMPIAR FORMULARIO Y CERRAR EL MODAL UNA VEZ GUARDADO.
    useEffect(() => {
        if (success === "success" && message.length > 0) {
           cancelAction();
        } 
    }, [success]);

    // ? HOOK-EFFECT PARA CARGAR LA DATA EN CASO DE QUE SE EDITE.
    useEffect(() => {
      if(Object.keys(open.data).length > 0){

        // * DESESTRUCTURACION DE LOS DATOS.
        const { activo: estatus, fechaInicio, fechaTermino, id } = open.data;

        const semana = {
            id,
            fechaInicio,
            fechaTermino,
            estatus
        };

        // * CARGAR DATA EN EL HOOK-FORM.
        setValue('semana', semana);
      }
      
    }, [open])

    // * FUNCION PARA CERRAR EL FORMULARIO.
    const cancelAction = () => {
        setOpen({data: {}, enable: false});
        reset()
    };

    // * FUNCION PARA ENVIAR DATA A BACK-END.
    const onSubmit = ({ semana }) => dispatch(fetchInsertOrUpdateSemanaAlmuerzo(semana));

  return (
    <Dialog
    PaperProps={{ sx: { width: "35%", height: "43%" } }}
    open={open.enable}
    maxWidth='lg'
    >
        <DialogTitle sx={{textTransform: 'uppercase'}} className='text-mem text-center'>Crear Nueva Semana Almuerzo</DialogTitle>
        <Divider />
            
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent>

                    <Stack>
                        <Stack mb={2}>
                            <Typography fontWeight='bold'>Fecha de Inicio</Typography>
                            <Controller
                            control={control}
                            name="semana.fechaInicio"
                            render={({ field }) => (
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                inputFormat='dd/MM/yyyy'
                                mask="__/__/____"
                                value={field.value}
                                onChange={(e) => field.onChange(e)}
                                renderInput={(params) => (
                                    <TextField
                                    height={10}
                                    className="form-control"
                                    style={{ height: 10 }}
                                    {...params}
                                    />
                                )}
                                />
                            </LocalizationProvider>
                            )}
                            />
                            <p hidden={!Boolean(errors?.semana?.fechaInicio)} className='text-danger mt-3'>{errors?.semana?.fechaInicio?.message}</p>
                        </Stack>
                    </Stack>

                    <Stack mt={Boolean(errors?.semana?.fechaInicio) ? 0 : 3}>
                        
                        <Stack mb={2}>
                            <Typography fontWeight='bold'>Fecha de Término</Typography>
                            <Controller
                            control={control}
                            name="semana.fechaTermino"
                            render={({ field }) => (
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                inputFormat='dd/MM/yyyy'
                                mask="__/__/____"
                                value={field.value}
                                minDate={watch('semana.fechaInicio')}
                                onChange={(e) => field.onChange(e)}
                                renderInput={(params) => (
                                    <TextField
                                    height={10}
                                    className="form-control"
                                    style={{ height: 10 }}
                                    {...params}
                                    />
                                )}
                                />
                            </LocalizationProvider>
                            )}

                            />
                        </Stack>

                        <p hidden={!Boolean(errors?.semana?.fechaTermino)} className='text-danger mt-3'>{errors?.semana?.fechaTermino?.message}</p>
                    </Stack>

                    <Stack mt={Boolean(errors?.semana?.fechaTermino) ? 0 : 3}>
                       <Stack mb={2}>
                            <Typography fontWeight='bold'>Estado</Typography>
                            <select {...register('semana.estatus')} className='form-control'>
                                <option value={true}>Activo</option>
                                <option value={false}>Inactivo</option>
                            </select>

                            <p hidden={!Boolean(errors?.semana?.estatus)} className='text-danger'>{errors?.semana?.estatus?.message}</p>
                       </Stack>
                    </Stack>

                

                </DialogContent>

                <Divider />

                <DialogActions className='justify-content-center'>
                    <button id='btn-cancelar' type='button' onClick={() => cancelAction()} className='btn btn-danger'><DoNotDisturbAltIcon sx={{marginTop: -0.5, marginRight: 0.5}}/>CANCELAR</button>
                    <button type='submit' id='btn-guardar' className='btn btn-primary-mem'><SaveIcon sx={{marginTop: -0.5, marginRight: 0.5}}/>GUARDAR</button>
                </DialogActions>
            </form>

    </Dialog>
  )
}
